var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2859 10.8685C21.1017 10.3836 20.637 10.0631 20.1184 10.0631L14.1082 10.0631L14.1082 6.62719C14.1068 6.4096 14.047 6.19636 13.935 6.00978C13.8231 5.8232 13.663 5.67012 13.4717 5.56654C13.2803 5.46296 13.0646 5.41268 12.8472 5.42096C12.6298 5.42924 12.4185 5.49577 12.2356 5.6136C8.08542 7.41004 5.91713 8.72332 2.31448 11.6006C1.97315 11.8732 1.72852 12.222 1.72852 12.64C1.72852 13.058 2.02223 13.4064 2.31448 13.6793C5.78017 16.9163 7.95936 18.2182 12.2356 19.6664C12.4204 19.7769 12.6312 19.8363 12.8464 19.8385C13.0617 19.8407 13.2737 19.7857 13.4607 19.6791C13.6477 19.5725 13.803 19.4181 13.9107 19.2317C14.0185 19.0454 14.0748 18.8337 14.0738 18.6184L14.0738 15.1825L20.2312 15.1825C20.6667 15.1825 21.0624 14.9293 21.2449 14.534V14.534C21.7478 13.4444 21.7911 12.1983 21.3649 11.0765L21.2859 10.8685Z",
    fill: "#84C70D",
    fillOpacity: 0.4,
    stroke: "#84C70D",
    strokeWidth: 1.89474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.49638f554b8d43159a3992329cdb86ed.svg";
export { ForwardRef as ReactComponent };